import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-glm-badge',
  standalone: false,
  templateUrl: './glm-badge.component.html',
  styleUrls: ['./glm-badge.component.scss']
})
export class GlmBadgeComponent implements OnInit {

  @Input()
  display: string;

  @Input()
  toolTip: string;

  @Input()
  imgName: string;

  @Input()
  pequeno = false;

  imgBGStyle: string;

  constructor() {
  }

  ngOnInit() {
    this.imgBGStyle = this.imgName ? `url('./../../../../assets/${this.imgName}.svg')`
      : `url('./../../../../assets/badge.svg')`;
  }

}
